import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { ReactNode } from "react";
import styled, { css } from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

export interface PageLayoutStyles {
    breadcrumbWrapper?: InjectableCss;
}

export const pageLayoutStyles: PageLayoutStyles = {
    breadcrumbWrapper: {
        css: css`
            padding-top: 190px !important;
            & + main {
                padding-top: 10px !important;
            }
            @media print {
                padding-top: 0px !important;
            }
            transition: all 0.3s ease;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 200px !important;
                        @media print {
                            padding-top: 0px !important;
                        }
                    `,
                    css`
                        padding-top: 195px !important;
                        @media print {
                            padding-top: 0px !important;
                        }
                    `,
                    css`
                        padding-top: 195px !important;
                        @media print {
                            padding-top: 0px !important;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = pageLayoutStyles;

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
}: PageLayoutProps) => {
    return (
        <PageLayoutWrapper>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page as="div" {...(showBreadcrumbs ? { ...styles.breadcrumbWrapper } : undefined)}>
                    <PageBreadcrumbs />
                </Page>
            )}
            {pageContent}
            {showFooter && footer}
            {showSignInOverlay && signInOverlay}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
        </PageLayoutWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
        padding-top: 172px;
    }

    @media print {
        display: block;
    }
`;

export default PageLayout;
